import { useMemo } from 'react'
import { useGetOne } from 'react-admin'
import { getTargetRangeForSpecies, isSpeciesBacked } from '../types/dashboard'

/**
 * Hook that resolves species-specific glucose target ranges for a pet.
 * Fetches the pet record to determine species, then returns the appropriate
 * target min/max. Falls back to dog defaults if pet is not found or species is unrecognized.
 */
export function useSpeciesTargetRange(petId?: string | number | null) {
  const { data: pet } = useGetOne('pets', { id: petId! }, { enabled: petId != null })

  const range = useMemo(() => {
    return getTargetRangeForSpecies(pet?.species)
  }, [pet?.species])

  return {
    targetMin: range.min,
    targetMax: range.max,
    highMax: range.high,
    species: pet?.species as string | undefined,
    // True when the species has no band of its own and is silently receiving
    // DOG values. Only meaningful once the pet has loaded — an unresolved pet
    // is not a defaulted species, so gate on `pet` to avoid flashing the
    // disclosure during load.
    isSpeciesDefaulted: pet != null && !isSpeciesBacked(pet?.species),
  }
}
